module.exports = __webpack_public_path__ + "img/4.404a45dc.png";